
import EoButton from '../EoButton/EoButton.vue'
import EoIcon from '../EoIcon/EoIcon.vue'

export default {
  name: 'EoTab',
  components: {
    EoButton,
    EoIcon,
  },
  props: {
    /**
     * Label on the tab
     */
    label: {
      type: String,
      required: true,
      default: null,
    },
    /**
     * Hyperlink to url, page or anchor tag
     */
    to: {
      type: String,
      default: null,
    },
    /**
     * Prefetches the page behind the link
     */
    prefetch: {
      type: Boolean,
      default: true,
    },
    /**
     * Target for the label: (_self) (_blank)
     */
    target: {
      type: String,
      default: null,
    },
    /**
     * Only activate tab when the path is exact match with route
     */
    exact: {
      type: Boolean,
      default: true,
    },
    /**
     * Icon to show before label
     */
    icon: {
      type: String,
      default: null,
    },
    /**
     * Style: text color of the tab label
     */
    labelTextColor: {
      type: String,
      default: null,
    },
    /**
     * Style: text color of the selected tab label
     */
    labelTextColorActive: {
      type: String,
      default: null,
    },
    /**
     * Style: slider color for only this tab
     */
    sliderColor: {
      type: String,
      default: null,
    },
    /**
     * Style: visually hide the label, but make it visible for screen readers
     */
    labelHidden: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      index: null,
      isSelected: false,
      hasRouteMatch: false,
      hasRouteMatchExact: false,
    }
  },
  computed: {
    classesContent () {
      return {
        'eo-tab': true,
        'is-selected': this.isSelected,
        ...this.$attrs.class,
      }
    },
    classesLabel () {
      return {
        'eo-tab__label': true,
        'is-selected': this.isSelected,
      }
    },
    dynamicLabelTextColor () {
      const labelTextColor = this.labelTextColor || this.parentTabs?.labelTextColor
      const labelTextColorActive = this.labelTextColorActive || this.parentTabs?.labelTextColorActive
      return this.isSelected ? labelTextColorActive || labelTextColor : labelTextColor
    },
    hasContent () {
      return this.$slots.default
    },
    parentTabs () {
      let parentTabs = null
      let parent = this.$parent
      while (parent && !parentTabs) {
        if (parent.$options.name === 'EoTabs') {
          parentTabs = parent
        }
        parent = parent.$parent
      }
      return parentTabs
    },
  },
  watch: {
    '$route': {
      handler: 'onChangeRoute',
      immediate: true,
    },
  },
  mounted () {
    if (this.parentTabs) {
      this.index = this.parentTabs.tabs.length
      this.parentTabs.tabs.push(this)
      this.parentTabs.findTabMatchingRoute()
    }
  },
  methods: {
    setTabAsSelected () {
      if (!this.parentTabs) return
      this.parentTabs.setSelectedTab(this.index)
    },
    async onChangeRoute () {
      // Let the route tell us if this tab should be active
      if (!this.to) return
      if (!this.$route.path) return
      this.hasRouteMatch = this.$route.path.includes(this.to)
      this.hasRouteMatchExact = this.$route.path === this.to
      this.parentTabs.findTabMatchingRoute()
    },
  },
}
